// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input,
select {
    padding: 10px;
    margin: 5px 0;
    display: inline-block;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 0.9em;
}

form {
    max-width: 800px;
}

.form-input-area {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    font-size: 1rem;
}

.form-input-area h2 {
    font-size: 1em;
    color: #555;
}

.multiline-input {
    height: 5rem;
    resize: vertical;
    width: 100%;
}

.form-input-area__input-row {
    padding: 5px 10px;
    background-color: white;
    border-bottom: 1px solid #aaa;
    display: table;
    table-layout: fixed;
    width: 100%;
    min-height: 3em;
}

.form-input-area__input-row>div {
    display: table-cell;
    width: 60%;
    vertical-align: middle;
}

.dr-checklist .form-input-area__input-row>div {
    width: inherit;
}

.form-input-area__input {
    display: inline;
    margin-right: 10px;
}

input.error {
    border-color: red;
}

.form-input-area__input-row h3 {
    display: table-cell;
    margin-right: 10px;
    font-size: 0.9em;
    width: 300px;
    vertical-align: middle;

    padding: 0.5em 3em 0.5em 0.5em;
}

.dr-checklist .form-input-area__input-row h3 {
    width: 600px;
}

@media (max-width: 1100px) {
    .form-input-area__input-row h3 {
        font-size: 0.8em;
    }
}

.required-input {
    color: red;
}

.financial-warning {
    color: red;
    text-align: center;
}

.annotated-input-container {
    position: relative;
    display: inline-block;
}

.annotated-input-container .input-annotation-icon {
    position: absolute;
    left: 0;
    top: calc(50% - 0.65em);
    padding: 0 0.5em;
}

input.annotated-input {
    padding-left: 2em;
}

.annotated-input-container .input-annotation-icon-right {
    position: absolute;
    right: 0;
    top: calc(50% - 0.5em);
    padding: 0 0.5em;
}

input.annotated-input-right {
    padding-right: 2em;
}

input[type="text"],
input.number {
    width: 220px;
}

.form-input-area__input--full-width {
    display: block;
    width: 100%;
    margin-right: 0;
}

.form-input-area__input--full-width label {
    display: block;
    width: 100%;
}

.form-input-area__input--full-width input[type="text"] {
    width: 100%;
}

.row-with-headers {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
}

.row-with-headers>div {
    text-align: center;
    flex: 1 1;
}

input[type="checkbox"] {
    -webkit-appearance: none;
    width: 15px;
    height: 15px;
    background: white;
    border-radius: 5px;
    border: 2px solid #555;
    position: relative;
    vertical-align: middle;
    margin-right: 7px;
}

input[type="checkbox"]:checked {
    background: var(--primary-color);
}

input[type="checkbox"]:checked:after {
    content: "\\2713";
    font-size: 19px;
    color: #fff;
    position: absolute;
    top: -2px;
    left: 2px;
}

.error-message {
    color: red;
    font-size: 0.8em;
    margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/DataCollection/DataCollection.css"],"names":[],"mappings":"AAAA;;IAEI,aAAa;IACb,aAAa;IACb,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,6BAA6B;IAC7B,cAAc;IACd,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;;IAEtB,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;AACb;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":["input,\nselect {\n    padding: 10px;\n    margin: 5px 0;\n    display: inline-block;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-sizing: border-box;\n    font-size: 0.9em;\n}\n\nform {\n    max-width: 800px;\n}\n\n.form-input-area {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 20px;\n    font-size: 1rem;\n}\n\n.form-input-area h2 {\n    font-size: 1em;\n    color: #555;\n}\n\n.multiline-input {\n    height: 5rem;\n    resize: vertical;\n    width: 100%;\n}\n\n.form-input-area__input-row {\n    padding: 5px 10px;\n    background-color: white;\n    border-bottom: 1px solid #aaa;\n    display: table;\n    table-layout: fixed;\n    width: 100%;\n    min-height: 3em;\n}\n\n.form-input-area__input-row>div {\n    display: table-cell;\n    width: 60%;\n    vertical-align: middle;\n}\n\n.dr-checklist .form-input-area__input-row>div {\n    width: inherit;\n}\n\n.form-input-area__input {\n    display: inline;\n    margin-right: 10px;\n}\n\ninput.error {\n    border-color: red;\n}\n\n.form-input-area__input-row h3 {\n    display: table-cell;\n    margin-right: 10px;\n    font-size: 0.9em;\n    width: 300px;\n    vertical-align: middle;\n\n    padding: 0.5em 3em 0.5em 0.5em;\n}\n\n.dr-checklist .form-input-area__input-row h3 {\n    width: 600px;\n}\n\n@media (max-width: 1100px) {\n    .form-input-area__input-row h3 {\n        font-size: 0.8em;\n    }\n}\n\n.required-input {\n    color: red;\n}\n\n.financial-warning {\n    color: red;\n    text-align: center;\n}\n\n.annotated-input-container {\n    position: relative;\n    display: inline-block;\n}\n\n.annotated-input-container .input-annotation-icon {\n    position: absolute;\n    left: 0;\n    top: calc(50% - 0.65em);\n    padding: 0 0.5em;\n}\n\ninput.annotated-input {\n    padding-left: 2em;\n}\n\n.annotated-input-container .input-annotation-icon-right {\n    position: absolute;\n    right: 0;\n    top: calc(50% - 0.5em);\n    padding: 0 0.5em;\n}\n\ninput.annotated-input-right {\n    padding-right: 2em;\n}\n\ninput[type=\"text\"],\ninput.number {\n    width: 220px;\n}\n\n.form-input-area__input--full-width {\n    display: block;\n    width: 100%;\n    margin-right: 0;\n}\n\n.form-input-area__input--full-width label {\n    display: block;\n    width: 100%;\n}\n\n.form-input-area__input--full-width input[type=\"text\"] {\n    width: 100%;\n}\n\n.row-with-headers {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    flex-direction: row;\n}\n\n.row-with-headers>div {\n    text-align: center;\n    flex: 1 1 0;\n}\n\ninput[type=\"checkbox\"] {\n    -webkit-appearance: none;\n    width: 15px;\n    height: 15px;\n    background: white;\n    border-radius: 5px;\n    border: 2px solid #555;\n    position: relative;\n    vertical-align: middle;\n    margin-right: 7px;\n}\n\ninput[type=\"checkbox\"]:checked {\n    background: var(--primary-color);\n}\n\ninput[type=\"checkbox\"]:checked:after {\n    content: \"\\2713\";\n    font-size: 19px;\n    color: #fff;\n    position: absolute;\n    top: -2px;\n    left: 2px;\n}\n\n.error-message {\n    color: red;\n    font-size: 0.8em;\n    margin-top: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
